export default __webpack_public_path__ + "static/media/brochure.17f05177.jpg";